import tinycolor from 'tinycolor2';
import { path } from 'ramda';
import { B as BaseTheme } from './base-57e9514e.js';
import 'react';
import '@amtrav/icons';

const getThemeProp = function (name) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return props => {
    const themeObj = props.theme || BaseTheme;
    const propValue = path(name.split('.'), themeObj);
    return propValue || defaultValue;
  };
};
const lighten = function (colorStr) {
  let amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
  return tinycolor.mix(colorStr, 'white', amount).toString();
};
const darken = function (colorStr) {
  let amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return tinycolor(colorStr).darken(amount).toString();
};

export { darken, getThemeProp, lighten };
//# sourceMappingURL=helpers.js.map
